import { PaletteColor } from '@mui/material';

import { theme } from '~/theme';

export const useSXStyles = () => {
  const getDialogTypeStyle = (color: PaletteColor) => {
    return {
      backgroundColor: color.main, //'#FFCC00',
      color: color.contrastText,
      '.MuiButtonBase-root': { color: color.contrastText },
    };
  };

  return {
    dialog: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateAreas: '"icon title actions close"',
      alignItems: 'center',
    },
    icon: {
      gridArea: 'icon',
      display: 'flex',
      marginRight: theme.spacing(1),
    },
    title: {
      gridArea: 'title',
    },
    actions: {
      gridArea: 'actions',
      display: 'flex',
      margin: theme.spacing(-1, -1, -1, 1),
    },
    actionsDivider: {
      height: '1em',
      alignSelf: 'center',
      margin: theme.spacing(0, 1),
    },
    close: {
      gridArea: 'close',
      margin: theme.spacing(-1, -1, -1, 1),
    },
    info: getDialogTypeStyle(theme.palette.info),
    success: getDialogTypeStyle(theme.palette.success),
    warning: getDialogTypeStyle(theme.palette.warning),
    error: getDialogTypeStyle(theme.palette.error),
  };
};
